// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__18izf","info":"Note_info__3WtEj","note":"Note_note__RPB9D","actions":"Note_actions__Joj-X"};